import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { EDIT_THEME, THEMES_LIST, UPDATE_THEME_STATUS, UPDATE_THEME_ORDER_STATUS, DELETE_THEME } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { ADD_THEME } from "../Constants";
import { EditThemeFailure, EditThemeSuccess, ThemeListFailure, ThemeListSuccess, UpdateThemeStatusFailure, UpdateThemeStatusSuccess, UpdateThemeOrderStatusSuccess, UpdateThemeOrderStatusFailure, AddThemeSuccess, AddThemeFailure, deleteThemeSuccess, deleteThemeFailure } from "../Actions/ThemesListAction";
import { logout } from "../../utils";

function* ThemeListRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/themes`, {
      headers: defaultHeaders(),
      params: {
        status: actions.payload.status,
      },
    });
    if (res.status === 200) {
      yield put(ThemeListSuccess(res.data));
    } else yield put(ThemeListFailure(res));
  } catch (e) {
    yield put(ThemeListFailure(e));
  }
}

function* UpdateThemeStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_theme_status`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(UpdateThemeStatusSuccess(res.data));
    } else {
      yield put(UpdateThemeStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateThemeStatusFailure(e));
  }
}

function* EditThemeRequest(actions) {
  console.log(actions);
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    id: actions.payload.id,
    title: actions.payload.title,
    text_color: actions.payload.text_color,
    card_color: actions.payload.card_color,
    primary_color: actions.payload.primary_color,
    background_color: actions.payload.background_color,
    icon_color: actions.payload.icon_color,
    header_card_image: actions.payload.header_card_image,
    icon: actions.payload.icon,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_theme`, getFormData(body), { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(EditThemeSuccess(res.data));
    } else {
      yield put(EditThemeFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditThemeFailure(e));
  }
}

function* AddThemeRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  const data = {
    title: actions.payload.title,
    header_card_image: actions.payload.pngSrc,
    icon: actions.payload.icon,
    text_color: actions.payload.textColor,
    card_color: actions.payload.cardColor,
    primary_color: actions.payload.primaryColor,
    background_color: actions.payload.backgroundColor,
    icon_color: actions.payload.iconColor,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_theme`, getFormData(data), {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(AddThemeSuccess(res.data));
    } else yield put(AddThemeFailure(res));
  } catch (e) {
    yield put(AddThemeFailure(e));
  }
}

function* themeOrderStatusRequest(actions) {
  let data = [];
  actions.payload.map((arr) => {
    data.push(arr);
  });
  const body = {
    data,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_theme_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateThemeOrderStatusSuccess(res.data));
    } else yield put(UpdateThemeOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateThemeOrderStatusFailure(e));
  }
}

function* deleteThemeRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/theme/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(deleteThemeSuccess(res.data));
    } else yield put(deleteThemeFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(deleteThemeFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(THEMES_LIST, ThemeListRequest);
  yield takeLatest(ADD_THEME, AddThemeRequest);
  yield takeLatest(UPDATE_THEME_STATUS, UpdateThemeStatusRequest);
  yield takeLatest(EDIT_THEME, EditThemeRequest);
  yield takeLatest(UPDATE_THEME_ORDER_STATUS, themeOrderStatusRequest);
  yield takeLatest(DELETE_THEME, deleteThemeRequest);
}

export default function* ThemeSaga() {
  yield all([actionWatcher()]);
}
